<template>
    <table class="selected_table">
        <tr>
            <th>ブランド事業者名</th>
            <td>{{ selectedData.brandCompanyName }}</td>
        </tr>
        <tr>
            <th>発電ユニット番号</th>
            <td>{{ selectedData.powerUnitNumber }}</td>
        </tr>
        <tr>
            <th>貯湯ユニット品番</th>
            <td>{{ selectedData.tankUnitNumber }}</td>
        </tr>
        <tr>
            <th>補助熱源機品番</th>
            <td>{{ selectedData.backupBoilerNumber }}</td>
        </tr>
        <tr>
            <th>成績証明書番号または自己適合宣言書番号</th>
            <td>{{ selectedData.certificationNumber }}</td>
        </tr>
    </table>
</template>

<script>
/**
 * [プロパティ]
 * selectedData ... 選択された機器情報
 * 
 * [利用例]
 * <selected-cogen-table :selectedData="選択した検索結果"/>
 */
export default {
    name:"SelectedCogenTable",
    props: {
        /**
         * 選択された機器情報のObjectがそのまま入る
         */
        selectedData:{
            type:Object
        },
    },
}
</script>

<style scoped>
.selected_table{
    width: 100%;
    margin: 5px 10px;
}
.selected_table th{
    font-weight: 600;
    width: 50%;
}
</style>
